import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { CleardRulelog } from '../state/action/rules.actions';

@Component({
	selector: 'cv-rule-notifications',
	templateUrl: './rule-notifications.component.html',
	styleUrls: ['./rule-notifications.component.scss']
})
export class RuleNotificationsComponent {
	@Input() ruleLog: Array<any>;
	@Output() cancel: EventEmitter<any> = new EventEmitter<any>();

	constructor(private store: Store) {}

	/**
	 * On Cancel/Close panel form.
	 */
	public onCancel(): void {
		this.cancel.emit();
	}

	/**
	 * Clear the rule notifications
	 */
	public markAsRead(): void {
		this.store.dispatch(new CleardRulelog());
		this.cancel.emit();
	}
}
